import React from 'react';
import { FaWhatsapp, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = ({ contactInfo, address }) => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: <FaWhatsapp />, href: `https://wa.me/${contactInfo?.phoneNumbers?.[0]?.replace(/[^0-9]/g, '') || "918080779602"}`, label: "WhatsApp" },
    { icon: <FaFacebook />, href: "https://facebook.com/vaishnavieducare", label: "Facebook" },
    { icon: <FaInstagram />, href: "https://instagram.com/vaishnavieducare", label: "Instagram" },
    { icon: <FaLinkedin />, href: "https://linkedin.com/company/vaishnavieducare", label: "LinkedIn" },
  ];

  const formattedAddress = address ? [
    address.street,
    `${address.city}, ${address.state}, ${address.country}`
  ] : [
    "Sector 12, Block H, Pratap Bihar",
    "Ghaziabad, Uttar Pradesh, India"
  ];

  const phones = contactInfo?.phoneNumbers?.join(', ') || "+91 8080779602, +91 8368599479";

  return (
    <footer className="bg-white border-t border-slate-200 py-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Brand */}
          <div className="text-center md:text-left">
            <div className="flex items-center justify-center md:justify-start gap-3 mb-4">
              <img src="/logo.png" alt="Vaishnavi Educare Logo" className="h-8 w-auto" />
              <span className="text-lg font-bold font-heading text-primary-800">Vaishnavi Educare</span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-5 max-w-xs mx-auto md:mx-0">
              Empowering students with expert guidance and support for over 15 years. Secure your seat in top medical, ayurvedic, and engineering colleges.
            </p>
            <div className="flex gap-3 justify-center md:justify-start">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.label}
                  className="text-gray-500 hover:text-primary-700 transition-colors duration-150 text-lg"
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { label: 'Home', href: '#home' },
                { label: 'Services', href: '#services' },
                { label: 'MBBS in India', href: '#mbbs-india' },
                { label: 'MBBS in Nepal', href: '#study-abroad' },
                { label: 'College Information', href: '#colleges' },
                { label: 'About', href: '#about' },
                { label: 'Contact', href: '#contact' },
              ].map((link, i) => (
                <li key={i}>
                  <a href={link.href} className="text-sm text-gray-600 hover:text-primary-700 transition-colors duration-150">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="text-center md:text-left">
            <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wide mb-4">Contact Us</h3>
            <address className="not-italic text-sm text-gray-600 space-y-2">
              {formattedAddress.map((line, i) => <p key={i}>{line}</p>)}
              <p>Email: <a href="mailto:info@vaishnavieducare.com" className="hover:text-primary-700 transition-colors">info@vaishnavieducare.com</a></p>
              <p>Phone: {phones}</p>
              {contactInfo?.website && (
                <p>
                  <a href={contactInfo.website} className="text-primary-700 hover:underline" target="_blank" rel="noopener noreferrer">
                    {contactInfo.website.replace(/^https?:\/\//, '')}
                  </a>
                </p>
              )}
            </address>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-slate-100 text-center">
          <p className="text-sm text-gray-500">
            &copy; {currentYear} Vaishnavi Educare. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
